<template>
  <div class="regin-bg">
    <van-cell
      :title="title"
      is-link
      :value="info.region_name"
      @click="isShowRegionPicker = true"
    />
    <!-- 作品地區picker -->
    <van-popup v-model="isShowRegionPicker" position="bottom" :safe-area-inset-bottom="true">
      <van-picker
        show-toolbar
        :columns="regionList"
        :title="$t('publish.workRegion.placeholder')"
        :loading="isReginLoading"
        @confirm="confirmRegion"
        @cancel="isShowRegionPicker = false"
        @change="onChangeReg"
      />
    </van-popup>
  </div>
</template>

<script>
import { getRegoin } from "@/api/publish";
import Vue from "vue";
import {
  Cell,
  Popup,
  Picker,
} from "vant";
Vue.use(Cell);
Vue.use(Popup);
Vue.use(Picker);

  export default {
    props: {
      title: {
        type: String,
        default() {
          return this.$t('publish.workRegion.label')
        },
      },
      reginValue: {
        type: String,
        default: ""
      }
    },
    watch: {
      reginValue(newValue) {
        this.info.region_name = newValue;
      }
    },
    data () {
      return {
        info: {
          region: null,
          region_name: "",
        },
        isShowRegionPicker: false,
        isReginLoading: false,
        regionList: [
          {
            values: [],
            defaultIndex: 0,
          },
          {
            values: [""],
            defaultIndex: 0,
          },
          {
            values: [""],
            defaultIndex: 0,
          },
        ],
        currentRegType: 1,
        regionProvice: [],
        regionCity: [],
        regionArea: [],
        regionName: [],
      }
    },
    created() {
      this.getRegoinList({ regoin_id: 0 });
    },
    methods: {
      getRegoinList(regoinId) {
      this.isReginLoading = true;
      getRegoin(regoinId).then((res) => {
        if (res.code === 1 && res.data.length) {
          if (this.currentRegType === 1) {
            this.regionList[0]["values"] = res.data.map((item) => {
              return item.name;
            });
            this.regionProvice = res.data;
            this.currentRegType = 2;
            this.getRegoinList({ regoin_id: res.data[0]["id"] });
            if (!this.regionName.length) {
              this.regionName[0] = res.data[0]["name"];
            }
          } else if (this.currentRegType === 2) {
            let data = res.data.map((item) => {
              return item.name;
            });
            Vue.set(this.regionList, 1, { values: [...data], defaultIndex: 0 });
            this.regionCity = res.data;
            this.currentRegType = 3;
            this.getRegoinList({ regoin_id: res.data[0]["id"] });
          } else if (this.currentRegType === 3) {
            let data = res.data.map((item) => {
              return item.name;
            });
            this.regionList.splice(2, 1, {
              values: [...data],
              defaultIndex: 0,
            });
            this.regionArea = res.data;
          }
        } else {
          if(this.currentRegType===2){
            this.regionList.splice(1, 1, {
              values: [],
              defaultIndex: 0,
            });
          }
          this.regionList.splice(2, 1, {
            values: [],
            defaultIndex: 0,
          });
        }
        this.isReginLoading = false;
      });
    },
      //確認選擇地區
      confirmRegion(valueArr, indexArr) {
        let idList = [];
        this.regionProvice.find((value) => {
          if (valueArr[0] === value["name"]) {
            idList[0] = value["id"];
          }
        });
        this.regionCity.find((value) => {
          if (valueArr[1] === value["name"]) {
            idList[1] = value["id"];
          }
        });
        this.regionArea.find((value) => {
          if (valueArr[2] === value["name"]) {
            idList[2] = value["id"];
          }
        });
        let regNameList = valueArr.filter((item) => {
          if (item !== undefined) {
            return item;
          }
        });
        this.info.region_name = regNameList.join("/");
        this.info.region = idList[idList.length - 1];
        this.$emit("updateRegin", {name: this.info.region_name, id: this.info.region})
        this.isShowRegionPicker = false;
      },
      onChangeReg(picker, values) {
      console.log("values", values);
      console.log("regionName", this.regionName);
      if (values[0] !== this.regionName[0]) {
        this.regionProvice.find((item) => {
          if (item["name"] === values[0]) {
            this.currentRegType = 2;
            this.getRegoinList({ regoin_id: item["id"] });
          }
        });
      } else if (
        values[0] === this.regionName[0] &&
        values[1] !== this.regionName[1]
      ) {
        this.regionCity.find((item) => {
          if (item["name"] === values[1]) {
            this.currentRegType = 3;
            this.getRegoinList({ regoin_id: item["id"] });
          }
        });
      }
      this.regionName = values;
    },
    }
  }
</script>

<style lang="less" scoped>
.regin-bg {
  width: 100%;
}
// .van-cell {
//   padding: 10px 0;
// }
// .van-cell::after{
//   left: 0;
//   right: 0;
// }
.van-cell--borderless::after, .van-cell:last-child::after {
  display: inline-block;
}
</style>